import { render, staticRenderFns } from "./delivery-details.vue?vue&type=template&id=7f646b1e&scoped=true&"
import script from "./delivery-details.vue?vue&type=script&lang=js&"
export * from "./delivery-details.vue?vue&type=script&lang=js&"
import style0 from "./delivery-details.vue?vue&type=style&index=0&id=7f646b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f646b1e",
  null
  
)

export default component.exports